function Position(coordinates=[{x:0,y:0}], id=0) {
    this.coordinates = coordinates;
    this.xy = null;
    this.id = id;
    this.activeIndex = Math.floor(Math.random() * coordinates.length);
    this.direction = Math.random() + 0.495 > 0 ? 1 : -1;
}

Position.prototype.getX = function() {
    return this.getCoords().x;
}

Position.prototype.getY = function() {
    return this.getCoords().y;
}

Position.prototype.getId = function() {
    return this.id;
}

Position.prototype.setCustomCoords = function(x,y) {
    this.xy = {x:x, y:y};
}

Position.prototype.removeCustomCoords = function() {
    // tools.each(this.activeIndex)
    this.xy = null;

}


Position.prototype.getCoords = function () {
    return this.xy || this.coordinates[this.activeIndex];
}

Position.prototype.move = function() {
    let newIndex = 0;
    if(this.coordinates.length > 1) {
        newIndex = this.activeIndex + this.direction;
        if(newIndex >= this.coordinates.length - 1) {
            newIndex = this.coordinates.length - 1;
            this.direction = -1;
        } else if(newIndex <= 0) {
            newIndex = 0;
            this.direction = 1;
        }
    }

    this.activeIndex =  newIndex;
}

Position.prototype.toString = function() {
    return '{x: ' + this.getX() + ', y: ' + this.getY()+  '}';
}

Position.prototype.equals = function(position = new Position()) {
    return this.id === position.getId();
}

Position.prototype.animate = function() {
    this.move();
}

Position.prototype.stop = function() {}
export default Position;
